import { independentStudyApi } from '@/providers/apis/independent-study/independent-study';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
@Component({
    name: 'independent-study-filter',
    components: {
    },
})


export default class IndependentStudyFilter extends Vue {
    @Prop()
    public offset: any;
    @Prop()
    public limit: any;
    public totalcount: any;
    public selectedOption: any = null;
    public programList: any = [];
    @Prop()
    public filterItems: any;
    @Prop()
    public classification: any;
    public selectedMenuList: any = [];
    public selectedParentItem: any = null;
    public openDropdownList = false;
    public selectedSubjectIndex: any = null;
    public selectedFwIndex: any = null;
    public selectedGrade: any = null;
    public selectedClassificationIndex: any = null;
    public selectedClassification: any = null;
    public selectedSubject: any = null;
    public selectedFramework: any = null;
    public selectedGradeIndex: any = null;
    @Prop()
    public menuItems: any;
    public selectedDropdown: any;
    private openCreateProgam: boolean = false;
    private openEditProgam: boolean = false;
    public onClickCreate() {
        this.openEditProgam = true;
        this.$emit('onClickCreate', true);
    }

    public setSelectedItem(item: any) {
        this.selectedDropdown = item;
    }

    public async clearSelection(key: any) {
        this.menuItems.forEach((item: any) => {
            item.selected = false;
        });
        this.selectedClassificationIndex = null;
        this.selectedSubjectIndex = null;
        this.selectedFwIndex = null;
        this.selectedGradeIndex = null;
        this.$set(this.selectedOption, key, null);
        this.$emit('getProgramList', false);
        this.selectedMenuList = this.selectedMenuList.filter((item: any) => !this.isDependentFilter(item.key, key));
        this.clearDependent(key, false);
        this.$emit('changeOffset', 0);
        if (this.offset === 0) {
            await this.fetchFilteredProgram(true);
        }
        this.$emit('selectMenu', null, null, this.programList, this.totalcount);
    }

    public openDropdown() {
        this.openDropdownList = !this.openDropdownList;
    }

    public closeDropdown() {
        this.openDropdownList = false;
    }

    public toggleDropdown(index: any, item: any) {
        this.$emit('changeOffset', 0);
        item.selected = true;
        this.selectedMenuList = this.selectedMenuList.filter((itemList: any) => itemList.key !== item.key);
        this.selectedMenuList.push({ key: item.key, value: item.id || item.standard_framework_id, name: item.title
            || item.grade || item.name });
        this.selectedOption = {
            ...this.selectedOption,
            [item.key]: item.title || item.grade || item.name,
        };
        if (item.key === 'classification') {
            this.selectedClassificationIndex = index;
            this.selectedClassification = item;
        } else if (item.key === 'subject') {
            this.selectedSubjectIndex = index;
            this.selectedSubject = item;
        } else if (item.key === 'framework') {
            this.selectedFwIndex = index;
            this.selectedFramework = item;
        } else if (item.key === 'grade') {
            this.selectedGradeIndex = index;
            this.selectedGrade = item;
            this.openDropdownList = false;
        }
        this.onSelectClassification(this.menuItems, item);
    }

    public isDependentFilter(filterKey: string, removedKey: string) {
        const dependencies: any = {
            classification: ['framework', 'subject', 'grade'],
            framework: ['grade'],
            subject: ['framework', 'grade'],
        };
        const isDependent = filterKey === removedKey || (dependencies[removedKey] || []).includes(filterKey);
        if (isDependent && dependencies[removedKey]) {
            dependencies[removedKey].forEach((item: any) => {
                this.clearDependent(item, true);
            });
            this.$set(this.selectedOption, filterKey, null);
        }
        return isDependent;
    }

    public clearDependent(key: any, isDependent: any) {
        if (this.filterItems) {
            this.filterItems.map((item: any) => {
                if (item.key === key) {
                    item.isSelected = false;
                    if (isDependent) {
                        item.isVisible = false;
                    }
                }
            });
        }
    }

    public async onSelectClassification(menu: any, selectedItem: any) {
        if (this.offset === 0) {
            await this.fetchFilteredProgram(true);
        }
        this.$emit('selectHierarchyFilters', menu, selectedItem, this.programList, this.totalcount);
    }

    public async onSelectMenu(selectedItem: any, value: any) {
        this.$emit('changeOffset', 0);
        let selectedValue = value.title || value.grade || value.name || value;
        this.selectedOption = {
            ...this.selectedOption,
            [selectedItem.key]: selectedValue,
        };
        const selectedOption = selectedItem.options.find((item: any) => item.title === selectedValue);
        const keyMapping: any = {
            audience: 'value',
            pricetype: 'value',
            classification: 'id',
            subject: 'id',
            framework: 'standard_framework_id',
            grade: 'id',
        };
        if (selectedOption && keyMapping[selectedItem.key]) {
            selectedValue = selectedOption[keyMapping[selectedItem.key]];
        }
        this.selectedMenuList = this.selectedMenuList.filter((item: any) => item.key !== selectedItem.key);
        this.selectedMenuList.push({ key: selectedItem.key, value: selectedValue });
        selectedItem.isSelected = true;
        if (this.offset === 0) {
            await this.fetchFilteredProgram(true);
        }
        this.$emit('selectMenu', selectedItem.key, value, this.programList, this.totalcount);
    }

    public async fetchFilteredProgram(isFilter: any) {
        let programList: any = [];
        const params = {
            offset: this.offset,
            limit: this.limit,
        };
        await independentStudyApi.filterNavigatorPrograms(params, this.selectedMenuList).then((programs: any) => {
            programList = programs ? programs.serializedPrograms : [];
            this.totalcount = programs ? programs.totalCount : null;
            if (!programs) {
                this.$emit('getProgramList', true);
            }
        });
        if (isFilter || this.offset === 0) {
            this.programList = programList;
        } else {
            this.programList = [...this.programList, ...programList];
        }
    }

    public async created() {
        await this.fetchFilteredProgram(true);
        this.$emit('selectMenu', null, null, this.programList, this.totalcount);
    }
    @Watch('offset')
    public async changeOffset() {
        await this.fetchFilteredProgram(false);
        this.$emit('selectMenu', null, null, this.programList, this.totalcount);
    }
}
